module.exports = __webpack_public_path__ + "media/mayor_vid.a0d192e7.mp4";